import React from 'react';

const StoresPage = () => {
  return (
    <div>All stores page</div>
  );
};

export default StoresPage;
